export const AUTH_STORAGE_KEY = "mindpolis:vv:auth";
const LEGACY_STORAGE_KEYS = ["token", "user", "roles", "token_expiration"];

export const normalizeAuthSession = (data) => {
  if (!data?.access_token) return null;

  return {
    access_token: data.access_token,
    token_type: data.token_type || "bearer",
    expires_at: data.expires_at || Math.floor(Date.now() / 1000) + Number(data.expires_in || 0),
    user: data.user || null,
    cliente: data.cliente || null,
    permissoes: data.permissoes || null,
  };
};

export const getAuthSession = () => {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    if (raw) return JSON.parse(raw);

    const legacyToken = localStorage.getItem("token");
    if (!legacyToken) return null;

    const legacySession = {
      access_token: legacyToken,
      token_type: "bearer",
      expires_at: Number(localStorage.getItem("token_expiration") || 0),
      user: JSON.parse(localStorage.getItem("user") || "null"),
      cliente: null,
      permissoes: null,
    };

    if (legacySession.access_token && legacySession.expires_at) {
      localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(legacySession));
      LEGACY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
      return legacySession;
    }

    return null;
  } catch {
    clearAuthSession();
    return null;
  }
};

export const persistAuthSession = (data) => {
  const session = normalizeAuthSession(data);
  if (!session) return null;

  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
  LEGACY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  return session;
};

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  LEGACY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const isAuthSessionExpired = (session) => {
  if (!session?.access_token || !session?.expires_at) return true;
  return Date.now() / 1000 >= Number(session.expires_at);
};
